import { Link } from 'react-router-dom'
import './Error.css'

function NotFound() {
  return (
    <div className="error-page">
      <div className="error-content">
        <div className="error-illustration">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
            <circle cx="100" cy="100" r="80" fill="url(#error-gradient)" fillOpacity="0.1"/>
            <text x="100" y="115" textAnchor="middle" className="error-code-svg">404</text>
            <defs>
              <linearGradient id="error-gradient" x1="0" y1="0" x2="200" y2="200">
                <stop stopColor="#7C3AED"/>
                <stop offset="1" stopColor="#2563EB"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        
        <h1 className="error-title">Page not found</h1>
        <p className="error-description">
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back on track.
        </p>
        
        <div className="error-actions">
          <Link to="/" className="btn btn-primary">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            Go to homepage
          </Link>
          <Link to="/dashboard" className="btn btn-secondary">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="7" height="7"/>
              <rect x="14" y="3" width="7" height="7"/>
              <rect x="14" y="14" width="7" height="7"/>
              <rect x="3" y="14" width="7" height="7"/>
            </svg>
            Open dashboard
          </Link>
        </div>
        
        <div className="error-help">
          <p>Need help? <Link to="/support">Contact support</Link></p>
        </div>
      </div>
      
      <div className="error-decoration">
        <div className="decoration-orb orb-1"></div>
        <div className="decoration-orb orb-2"></div>
        <div className="decoration-orb orb-3"></div>
      </div>
    </div>
  )
}

export default NotFound
